module.exports = __webpack_public_path__ + "static/img/IMG_20150307_165150.bda177e9.jpg";